import { render, staticRenderFns } from "./ProducerSunExpert.vue?vue&type=template&id=445be7bf"
import script from "./ProducerSunExpert.vue?vue&type=script&lang=js"
export * from "./ProducerSunExpert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports